import React, { useEffect } from 'react';
import { useArtifactoryStore } from '../../stores/artifactoryStore';

export const ArtifactoryCommander: React.FC<{ sessionId: string, manifestId?: string }> = ({ sessionId, manifestId }) => {
  const { setManifestId, loadManifest, expandPathToNode, manifest, selectedNodeId } = useArtifactoryStore();

  // Set manifest ID and load manifest
  useEffect(() => {
    if (manifestId) {
      setManifestId(manifestId);
      loadManifest();
    }
  }, [manifestId, setManifestId, loadManifest]);

  // Ensure the path to the selected node is expanded when manifest loads
  useEffect(() => {
    if (manifest && selectedNodeId && manifest.nodes[selectedNodeId]) {
      const nodePath = manifest.nodes[selectedNodeId].path;
      expandPathToNode(nodePath);
    }
  }, [manifest, selectedNodeId, expandPathToNode]);

  return null; // This component is just a container for loading the manifest
};
